<template>
  <div id="app">
    <main role="main" id="main" class="main">
      <PageHeadful title="Cars"/>

      <AppHeader/>

      <!--      <transition name="fade" mode="out-in">-->
      <router-view/>
      <!--      </transition>-->
      <Footer v-if="showFooter"/>
    </main>
    <nav v-if="$store.state.isApp" class="mobile-actions">
      <phone-nav-btn/>
      <CarFormNavBtn v-if="showFormNavBtn" :loaded="$store.getters.carLoaded"/>

      <div
          v-for="(link, index) in pageLink"
          :key="index"
          @click="clickActionMob(link)"
          :class="[
          'mobile-action-link',
          { active: link.components.indexOf($route.name) >= 0 && showMenu },
        ]"
      >
        <component :is="link.icon"></component>
        <span>
          {{ link.name }}
        </span>
      </div>
    </nav>

    <!--    <transition name="fade">-->
    <!--  -->

    <div @click="bgClick" v-if="$store.state.popup" class="popupbg">
      <AppLogin v-if="$store.state.popup && $store.state.popup == 'sign-in'"/>
      <AppRegister v-show="$store.state.popup && $store.state.popup == 'reg'"/>
      <AppForgot v-if="$store.state.popup && $store.state.popup == 'forgot'"/>
      <GamePopUp v-if="$store.state.popup && $store.state.popup == 'game'"/>
      <fb-alert v-if="$store.state.fbModuleAlert" />
    </div>
    <!--    </transition>-->
    <CookiesBlock/>
  </div>
</template>

<script>
import Footer from "./components/Footer";
import AppHeader from "./components/Header.vue";
import AppLogin from "./components/login/SignIn.vue";
import AppRegister from "./components/login/Register.vue";
import AppForgot from "./components/login/Forgot.vue";

import PhoneNavBtn from "@/components/global/PhoneNavBtn";
import CarFormNavBtn from "./components/Dealers/CarFormNavBtn";
import PageHeadful from "headful";
import Vue from "vue";
import VueScrollTo from "vue-scrollto";
import setCordova from "./helpers/setCordova";
import inIframe from "./helpers/inIframe";

import routesNames from '@/router/constants'

import CookiesBlock from "@/components/CookiesBlock";
import Leita from "@/components/svg/nav/Leita";
import Favorites from "@/components/svg/nav/Favorites";
import Notifications from "@/components/svg/nav/Notifications";

import GamePopUp from "@/components/GameChick/GamePopUp.vue";
import fbAlert from "@/components/login/FbAlert";

import {mapGetters, mapMutations} from 'vuex';

export default {
  components: {
    AppHeader,
    AppLogin,
    Footer,
    AppRegister,
    AppForgot,
    PageHeadful,
    PhoneNavBtn,
    CarFormNavBtn,
    CookiesBlock,
    Leita,
    Favorites,
    Notifications,
    GamePopUp,
    fbAlert
  },
  data: () => ({
    title: "",
  }),
  methods: {
    ...mapMutations(['setShowMenu']),
    ...mapMutations({
      setData: "SET_DATA",
    }),
    getLink(link) {
      return `${
          link.name == 'Leita' && (this.$route.name == 'DealersCars' || this.$route.name == 'DealerCar')
              ? '/nyir-bilar'
              : link.name == 'Leita' && (this.$route.name == 'OldCars' || this.$route.name == 'Car')
                  ? '/notadir-bilar'
                  : link.link
      }`
    },
    clickActionMob(link) {
      if (link.link === '/') {
        const carsPage = ['k7Cars', 'OldCars', 'DealersCars'];
        if (!carsPage.includes(this.$route.name)) {
          if (this.lastCarPageVisit.name && this.lastCarPageVisit.name == 'Car') {
            this.$router.push({name: 'OldCars'});
          } else if (this.lastCarPageVisit.name && this.lastCarPageVisit.name == 'DealerCar') {
            this.$router.push({name: 'DealersCars'});
          } else if (this.lastCarPageVisit.name) {
            this.$router.push({name: this.lastCarPageVisit.name});
          } else {
            this.$router.push({name: 'DealersCars'});
          }
          this.setShowMenu(true);
        } else {
          this.setShowMenu(!this.showMenu);
        }
        return false;
      }

      const defaultFilters = {
        brands: [],
        brand_model: [],
        fuel_type: [],
        argerd: [1999, 2021],
        verd: [0, 20000000],
        ekinn: [0, 287000],
        girartegund: [],
        flokkar: [],
        other: [],
        vt: [],
        verdtilbod: false,
        category: [],
        sort: {
          field: "",
          order: "",
        },
        parking: false,
        companies: [],
      };

      this.setData({
        field: "scrollPositionPageOldCars",
        data: 0,
      });
      this.setData({
        field: "scrollPositionPageDealers",
        data: 0,
      });
      this.setData({
        field: "moduleOldCars.cars.scrollTop",
        data: 0,
      });

      this.setData({
        field: "moduleDealers.page",
        data: {},
      });
      this.setData({
        field: "moduleOldCars",
        data: {
          carLoaded: false,
          cars: {
            scrollTop: 0,
            filters: defaultFilters,
            items: [],
            loaded: false,
          },
        },
      });
      this.$router.push(this.getLink(link))
    },
    setStoreScreenWidth() {
      this.$store.state.screen.width = window.innerWidth;
    },
    resizeWindow() {
      window.addEventListener("resize", () => {
        this.setStoreScreenWidth();
      });
    },
    bgClick(e) {
      if (
          e.target.classList.contains("popupbg") ||
          e.target.classList.contains("blackout")
      ) {
        this.$store.state.popup = null;
      }
    },
  },
  created() {
    if (!inIframe() && localStorage.getItem("access_token")) {
      this.$store.state.access_token = localStorage.getItem("access_token");
      Vue.http.headers.common["x-authorization"] = this.$store.state.access_token;
    }

    if (this.$store.state.isApp) {
      setCordova();
    }

    if (this.$device.ios() && this.$store.state.isApp) {
      Vue.use(VueScrollTo, {
        container: "body.ios.app #main > :nth-child(2)",
      });
    } else {
      Vue.use(VueScrollTo);
    }
  },
  mounted() {
    this.setStoreScreenWidth();
    this.resizeWindow();

    this.$store.dispatch("GET_PROFILE");
    this.$store.dispatch("GET_LIB");

    if (this.$store.state.isApp) {
      document.querySelector("body").classList.add("app");
      document.querySelector("html").classList.add("app");
    }

    if (this.$device.mobile()) {
      document.querySelector("body").classList.add("mobile");
    }

    if (this.$device.tablet()) {
      document.querySelector("body").classList.add("tablet");
    }

    if (this.$device.ios()) {
      document.querySelector("body").classList.add("ios");
    }

    /*    if (this.$device.ios()) {
      loadJsFile(this.$store.state.baseUrl + '/js/fastclick.js', function () {
        if (FastClick) {
          FastClick.attach(document.body);
        }
      });
    }*/
  },
  computed: {
    ...mapGetters(['showMenu', 'lastCarPageVisit']),
    routeNames() {
      return routesNames
    },
    pageLink() {
      return (
          this.$store.state.pageLinks &&
          this.$store.state.pageLinks.filter(function (e) {
            return e.target && e.target.indexOf("appBottom") >= 0;
          })
      );
    },
    showFormNavBtn() {
      return ["CarInStock", "Car", "DealerCar"].includes(this.$route.name);
    },
    showFooter() {
      const disabledFooter = ['Blog', 'PriceList', 'Fréttir', 'Reynsluakstur'];
      if (disabledFooter.includes(this.$route.name)) {
        return false;
      }
      return true;
    }
  },
  watch: {
    "$store.state.popup": function (to, from) {
      if (from === 'game' && to === null) {
        window.location.reload();
      }
      if (from === null) {
        this.title = document.title;
      }

      if (to === null) {
        document.title = this.title;
      }
      document.body.style.overflow = this.$store.state.popup ? "hidden" : "";
    },
    "$route.path": function () {
      this.$store.state.popup = null;
    },
  },
};
</script>